import React, { ReactNode } from "react";

import { color } from "minimum-ui/tokens";
import styled from "styled-components";
import { H3SB } from "typography/headers";

export interface UploadTabProps {
  label: string;
  render: () => ReactNode;
}

interface Props {
  tabs: UploadTabProps[];
  activeTabIndex?: number;
}

export const UploadTabContent: React.FC<Props> = ({
  tabs,
  activeTabIndex = 0,
}) => {
  return (
    <Container>
      <Header>
        <Tab>{tabs[activeTabIndex]?.label}</Tab>
      </Header>
      <ContentWrapper key={activeTabIndex}>
        {tabs[activeTabIndex]?.render()}
      </ContentWrapper>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid ${color.neutral[200]};
  padding-top: 1rem;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 1rem;
`;

const Tab = styled(H3SB)``;

const ContentWrapper = styled.div`
  margin-top: 16px;
`;
